import React from 'react';

import { InputAdornment, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, TextField } from '@hydra/common/components';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles({
  startAdornment: {
    width: 10,
    height: 10,
    borderRadius: '100%'
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5
  }
});

interface CompetitorInputProps {
  value: string
  label: string
  name: string
  placeholder: string
  handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  handleClear: (name: string) => void
  color: string
  valid: boolean,
  disabled?: boolean,
  helperText?: string
}

export default function CompetitorInput ({
  value,
  name,
  label,
  placeholder,
  handleClear,
  handleChange,
  color,
  valid,
  disabled,
  helperText
}: CompetitorInputProps) {
  const { translate } = useI18n();
  const classes = useStyles();
  const adornmentProps = { disablePointerEvents: disabled, className: disabled ? classes.disabled : '' };
  return (
    <TextField
      id={name}
      name={name}
      label={label}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      error={!valid}
      disabled={disabled}
      InputProps={{
        disabled: disabled,
        startAdornment: (
          <InputAdornment position='start' {...adornmentProps}>
            <span className={classes.startAdornment} style={{ background: color }} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position='end' {...adornmentProps}>
            <IconButton disabled={disabled} size='small' onClick={() => handleClear(name)} tabIndex='-1'>
              <Icon type='cross' size='sm' color='secondary' />
            </IconButton>
          </InputAdornment>
        )
      }}
      helperText={!valid && helperText && translate(helperText)}
    />
  );
}
